var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelBedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.33333V26.6667C4.5 27.9237 4.5 28.5523 4.89052 28.9428C5.28105 29.3333 5.90959 29.3333 7.16667 29.3333H25.8333C27.0904 29.3333 27.7189 29.3333 28.1095 28.9428C28.5 28.5523 28.5 27.9237 28.5 26.6667V5.33333",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.6667V12.6667M14.5 12.6667V14.6667M14.5 12.6667H18.5M18.5 10.6667V12.6667M18.5 12.6667V14.6667",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 29.3333V23.9999C19.1666 22.5272 17.9728 21.3332 16.5 21.3332C15.0272 21.3332 13.8333 22.5272 13.8333 23.9999V29.3333",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16669 5.33334H11.1667C12.0199 3.7697 14.0863 2.66667 16.5 2.66667C18.9138 2.66667 20.9802 3.7697 21.8334 5.33334H29.8334",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.6667H9.83333M8.5 16H9.83333M8.5 21.3333H9.83333",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 10.6667H24.5M23.1667 16H24.5M23.1667 21.3333H24.5",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelBedroom);
export default __webpack_public_path__ + "static/media/hotel-bedroom.e61df9472455fb3d1557d670ebea3c22.svg";
export { ForwardRef as ReactComponent };